export default "__VITE_ASSET__DyJ3uTxx__"